








import * as echarts from 'echarts'
import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import ResizeMixin from '@/components/resize'
import { HardwareTemperatures } from '@/services/dataService'

@Component({
  name: 'LineChart'
})
export default class TempLineChart extends mixins(ResizeMixin) {
  @Prop({ default: 'chart' }) private className!: string
  @Prop({ default: 'chart' }) private id!: string
  @Prop({ default: '100%' }) private width!: string
  @Prop({ default: '400px' }) private height!: string

  mounted () {
    this.$nextTick(() => {
      this.initChart([], '')
    })
  }

  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }

  public initChart (data: HardwareTemperatures[] = [], yAxisTitle: string) {
    if (data == null) return
    this.chart = echarts.init(document.getElementById(this.id) as HTMLDivElement)
    this.chart.setOption({
      backgroundColor: '#282c34',
      title: {
        top: 20,
        text: '',
        textStyle: {
          fontWeight: 'normal',
          fontSize: 16
        },
        left: '1%'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        top: 20,
        icon: 'rect',
        itemWidth: 14,
        itemHeight: 5,
        itemGap: 13,
        data: data.map(p => p.HardwareName),
        bottom: '4%',
        textStyle: {
          fontSize: 12,
          color: '#FFFFFF'
        }
      },
      grid: {
        top: 100,
        left: '2%',
        right: '2%',
        bottom: '2%',
        containLabel: true
      },
      xAxis: [{
        type: 'category',
        boundaryGap: false,
        axisLine: {
          lineStyle: {
            color: '#CCCCCC'
          }
        },
        data: data.length > 0 ? data[0].Temperatures.map(p => p.Created) : []
      }],
      yAxis: [{
        type: 'value',
        name: yAxisTitle,
        nameTextStyle: {
          fontSize: 16,
          color: '#CCCCCC',
          align: 'left',
          padding: [50, 0, 0, 0]
        },
        axisTick: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#CCCCCC'
          }
        },
        axisLabel: {
          margin: 10,
          fontSize: 14
        },
        splitLine: {
          lineStyle: {
            color: '#CCCCCC'
          }
        }
      }],
      series: data.map((p, index) => {
        return {
          name: p.HardwareName,
          type: 'line',
          smooth: false,
          symbol: 'circle',
          symbolSize: 5,
          showSymbol: false,
          lineStyle: {
            width: 2
          },
          itemStyle: {
            color: this.getRandomColor(index),
            borderColor: 'rgba(137,189,2,0.27)',
            borderWidth: 12
          },
          data: p.Temperatures.map(q => parseFloat(q.Value))
        }
      })
    })
  }

  getRandomColor (index: number) {
    return `rgb(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255})`
  }
}

